import invariant from 'tiny-invariant';
import { createContext, useContextSelector } from 'use-context-selector';
const MenuContext = createContext(null);
export const MenuProvider = MenuContext.Provider;
export const useMenuContext = () => useContextSelector(MenuContext, ctx => {
  invariant(ctx !== null, "Component can't be used outside of <Menu /> component");
  return ctx;
});